export class UserMapConfig {
    style: string;
    showTrafficLayer = true;
    showStopsNetwork = true;
    showRouteNetwork = true;
    showCityLabels = true;

    constructor(obj = null) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
}
